<template>
<div class="chapter">
<div class="inner_page">
<div class="box">
<p class="fig"><img alt="" src="images/pg7.jpg"/></p>
<p class="noinv">Determining what makes a great quilt is different for everyone. Most quilters agree that one important element of every beautiful quilt is impeccable piecing—square blocks, perfect points, little or no bulk in the seams. How do you get there? Practice, of course, trial and error, and learning a few tricks along the way.</p>
<p class="noindent">This book will show you how to use a few basic techniques to solve common problems in construction issues for a wide variety of quilt blocks. It will help you build a foundation of skills that you can apply to many different quiltmaking situations. Some techniques are helpful to know before tackling something new—for example, perfectly pieced strip sets make Four-Patch and Nine-Patch blocks a breeze, and often several techniques can be incorporated into piecing one block.</p>
<p class="noindent">I hope this book will help you look at blocks differently. Piecing methods are versatile, and there are different ways to construct a block. If a method works for you, then it works. Templates can be substituted for rotary-cut pieces, and half-square triangles and quarter-square triangles can be used in a myriad of ways. Let your creativity flow; experiment or dissect a block to make it easier to piece.</p>
<p class="noindent">Once you have the basic skills, you can make up some of your own rules. This may inspire you to develop your own technique for piecing a block. The only limit to solving a problem is you. The goal is to reach past your quilting style (for example, it’s not about modern or traditional) and focus solely on technique, making your piecing perfect, or at least making you feel less frustrated.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fm1.vue?02d92a16